<template>
    <dashboard-layout tit="근무지 근무 현황">
        <template slot="contents">
            <v-badge floating dot >
                <h4 class="tit--sm line-height-1">근무 현황 조회</h4>
            </v-badge>
            <!-- 검색필터 -->
            <worker-company-filter class="mt-12 mt-lg-20" :places="places" />

            <!-- 리스트 -->
            <worker-company-list class="mt-12 mt-lg-20" />

        </template>
    </dashboard-layout>
</template>

<script>
import api from '@/api';

import DashboardLayout from "@/components/dashboard/dashboard-layout.vue";
import WorkerCompanyFilter from "@/components/dashboard/company/worker/worker-company-filter.vue";
import WorkerCompanyList from "@/components/dashboard/company/worker/worker-company-list.vue";
import WorkerItem from "@/components/dashboard/company/worker/worker-item.vue";

export default {
    components: {
        DashboardLayout,
        WorkerCompanyFilter,
        WorkerCompanyList,
        WorkerItem,
    },
    data: () => ({
        places: [],
        place: {}
    }),
    computed: {
    },
    mounted() {
        this.placeList();
    },
    watch: {
    },
    methods: {
        async placeList() {
            try{
                let { places } = await api.v1.company.employment.places.gets({});

                this.places = places;
            } catch(e) {
                console.error(e);
            }
        }
    },
};
</script>

<style></style>
